<template>
  <DefaultLayout title="Liste des chants">
    <template v-slot:page-header>
      <div class="page-header-container">
        <div class="spacer"></div>
        <FilterBar class="song-list-header" />
        <div class="spacer">
          <router-link v-if="isAdmin" :to="{ name: 'new-song' }" class="btn btn-primary btn-add-song">
            <span class="d-none d-lg-block">Ajouter un chant</span>
            <span class="d-block d-lg-none"><i class="fa fa-plus"></i></span>
          </router-link>
        </div>
      </div>
    </template>
    <div class="home">
      <SongList />
    </div>
  </DefaultLayout>
</template>

<style scoped>
  .page-header-container {
    display: flex;
    justify-content: space-between;
  }
  .spacer {
    text-align: right;
    display: inline-block;
  }
  @media (min-width: 576px) {
    .spacer {
      width: 50px;
    }
  }
  @media (min-width: 992px) {
    .spacer {
      width: 180px;
    }
  }
</style>

<script>
// @ is an alias to /src
import {mapGetters} from "vuex";
import SongList from "@/components/SongList";
import FilterBar from "@/components/FilterBar";
import DefaultLayout from "@/layouts/DefaultLayout";

export default {
  name: 'home',
  components: {
    SongList,
    FilterBar,
    DefaultLayout
  },
  computed: {
    ...mapGetters(["isAdmin"])
  }
}
</script>
